<template>
  <QuestionBase :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="!!data">
    <InputBasic v-model="data"
                :args="args"
                :db="db"
                :noSave="noSave"
                :skipped="skipped"
                @jsErrors="jsErrors=$event"
                @serverErrors="serverErrors=$event"
                @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputBasic from "@/components/common/questionnaires/question/inputs/InputBasic";

export default {
  name: 'EstateAgentContactEmail',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: [
        Number,
        String
      ],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'Is there an email address for the estate agency?',
        subTitle: '',
        tip: null
      },
      db: {
        saveLocation: `conveyance_quote?code=${this.$route.params.code}`,
        saveField: 'purchase_estate_agent_contact_email',
      },
      args: {
        placeholder: 'e.g.  ',
        label: null,
        type: 'text',
        skippable: false,
        required: true,
        inputClass: 'field-100',
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>